import styled from '@emotion/styled';
import {colors, sizes} from 'patient-ping-remedy/packages/theme';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${sizes.xSmall};
  background: ${colors.white};
  border-bottom: ${colors.gray2} 1px solid;
  padding: 1rem 3rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const BackButton = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.8rem;
  height: 2.8rem;
  border-radius: 50%;
  border: none;
  outline: none;
  background: none;
  user-select: none;
  cursor: pointer;

  &:hover {
    background-color: ${colors.gray2};
  }

  &:focus-visible {
    outline: 2px solid ${colors.purple5};
    outline-offset: 2px;
  }
`;

export const BreadcrumbLink = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${colors.purple5};
  display: flex;
  align-items: center;
  font-size: 1.6rem;
  gap: ${sizes.xSmall};

  &:hover {
    color: ${colors.purple4};
  }
`;

export const Title = styled.span`
  font-size: 2rem;
  font-weight: 400;
`;


export const HeaderContentSlot = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
`;
